import i18n from "@/i18n";
export function getPublishedOptions() {
    return [
        {'label':i18n.t('yes'),'value':1},
        {'label':i18n.t('no'),'value':0},
    ]
}